import React from 'react';

import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';

import HelpIcon from '@mui/icons-material/Help';

import { TracklogOtherInfoEditable } from 'ff/debrief/features/TracklogApi';
import { RowContainer } from './styledInfoComponents';
import EditableField from './EditableField';

type Props = {
    label: React.ReactNode;
    value: string;
    border?: boolean;
    showSentryMsg?: boolean;
} & (
    | {
          editable?: false;
      }
    | {
          editable: true;
          editing: boolean;
          field: keyof TracklogOtherInfoEditable;
      }
);

const InfoRow = (props: React.PropsWithChildren<Props>) => {
    const MAX_ROW_HEIGHT = 80;
    return (
        <RowContainer border={props.border}>
            <Typography display="flex" alignItems="center" gap={1}>
                <span>{props.label}</span>
                {props.showSentryMsg && (
                    <Tooltip title="Available with Sentry Plus">
                        <HelpIcon fontSize="small" sx={{ color: '#B4B4B4' }} />
                    </Tooltip>
                )}
            </Typography>
            {props.editable && props.editing ? (
                <EditableField
                    field={props.field}
                    slotProps={{
                        htmlInput: { sx: { 'text-align': 'end' } },
                    }}
                />
            ) : (
                <Typography
                    fontWeight="bold"
                    whiteSpace="pre-wrap"
                    maxHeight={MAX_ROW_HEIGHT}
                >
                    {props.value}
                </Typography>
            )}
        </RowContainer>
    );
};

export default InfoRow;
